export const EXPERIMENT_USER_KEY = 'exps_guest_id';

export const PREFIX_BRANCH = 'exps-';

export const DEFAULT_BRANCH = 'original';

export const REFUND_ARTICLE_EXPERIMENT = 'uslgl-support-refund-article';
export const REFUND_ARTICLE_VIEW_METRIC = 'usl-refund-article-view';
